module.exports = __webpack_public_path__ + "img/TalentCom.ddab2a4d.png";